export const PERMISSION_KEYS = {
  DASHBOARD: 'dashboard',
  MANAGEMENT_SUBSCRIBER: 'management.subscriber',
  MANAGEMENT_SECURITY_FEE: 'management.securityFee',
  MANAGEMENT_AUTHORIZATION: 'management.authorization',
  MANAGEMENT_USER_PROFILE: 'management.userProfile',
  MANAGEMENT_AUDIT_TRAIL: 'management.auditTrail',
  MANAGEMENT_ACCOUNT_STATUS: 'management.accountStatus',
  REPORT: 'report',
};

export const MANAGEMENT_SUBMENU_PERMISSIONS = {
  Subscriber: PERMISSION_KEYS.MANAGEMENT_SUBSCRIBER,
  'Security Fee': PERMISSION_KEYS.MANAGEMENT_SECURITY_FEE,
  'File Processing Monitor': PERMISSION_KEYS.MANAGEMENT_SUBSCRIBER,
  Authorization: PERMISSION_KEYS.MANAGEMENT_AUTHORIZATION,
  'User Profiles': PERMISSION_KEYS.MANAGEMENT_USER_PROFILE,
  'Audit Trail': PERMISSION_KEYS.MANAGEMENT_AUDIT_TRAIL,
  'Account Status': PERMISSION_KEYS.MANAGEMENT_ACCOUNT_STATUS,
};

export const ALL_MANAGEMENT_SUBMENUS = [
  { key: 'Subscriber', labelKey: 'managementMenu.subscriber' },
  { key: 'Security Fee', labelKey: 'managementMenu.securityFee' },
  { key: 'File Processing Monitor', labelKey: 'managementMenu.fileProcessing' },
  { key: 'Authorization', labelKey: 'managementMenu.authorization' },
  { key: 'User Profiles', labelKey: 'managementMenu.userProfiles' },
  { key: 'Audit Trail', labelKey: 'managementMenu.auditTrail' },
  { key: 'Account Status', labelKey: 'managementMenu.accountStatus' },
];

export const DASHBOARD_SUBMENUS = [
  { key: 'Subscriber Dashboard', labelKey: 'dashboardMenu.subscriber' },
  { key: 'Security Fee Dashboard', labelKey: 'dashboardMenu.securityFee' },
];

export const REPORT_SUBMENUS = [
  { key: 'Subscribers Report', labelKey: 'reportMenu.subscribers' },
  { key: 'Security Fee Report', labelKey: 'reportMenu.securityFee' },
  { key: 'Invoice by Operator', labelKey: 'reportMenu.invoiceByOperator' },
  { key: 'Summary Report', labelKey: 'reportMenu.summary' },
  // { key: 'Top-up Report', labelKey: 'reportMenu.topup' },
];

const STORAGE_KEY = 'userPermissions';

export function loadStoredPermissions() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function savePermissions(permissions) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.isArray(permissions) ? permissions : []));
}

export function clearStoredPermissions() {
  localStorage.removeItem(STORAGE_KEY);
}

export function hasPermission(permissions, key) {
  if (!key) return false;
  return Array.isArray(permissions) && permissions.includes(key);
}

export function hasAnyPermission(permissions, keys = []) {
  return keys.some((key) => hasPermission(permissions, key));
}

export function canAccessDashboard(permissions) {
  return hasPermission(permissions, PERMISSION_KEYS.DASHBOARD);
}

export function canAccessReport(permissions) {
  return hasPermission(permissions, PERMISSION_KEYS.REPORT);
}

export function getVisibleManagementSubMenus(permissions) {
  return ALL_MANAGEMENT_SUBMENUS.filter((item) =>
    hasPermission(permissions, MANAGEMENT_SUBMENU_PERMISSIONS[item.key])
  );
}

export function canAccessManagement(permissions) {
  return getVisibleManagementSubMenus(permissions).length > 0;
}

export function getRoleLabel(role) {
  switch ((role || '').toLowerCase()) {
    case 'admin':
      return 'Administrator';
    case 'operator':
      return 'Operation';
    case 'viewer':
      return 'Viewer';
    default:
      return role || 'User';
  }
}

export function getDefaultTab(permissions) {
  if (canAccessDashboard(permissions)) return 'Dashboard';
  if (canAccessManagement(permissions)) return 'Management';
  if (canAccessReport(permissions)) return 'Report';
  return 'Dashboard';
}

export function getDefaultManagementSubMenu(permissions) {
  const visible = getVisibleManagementSubMenus(permissions);
  return visible[0]?.key || 'Subscriber';
}

export function canAccessManagementSubMenu(permissions, subMenu) {
  const key = MANAGEMENT_SUBMENU_PERMISSIONS[subMenu];
  return key ? hasPermission(permissions, key) : false;
}
